/* /ekstenzije-za-kosu (/en/clip-in-hair-extensions, /de/clip-in-extensions)

   A product page, not a service page. Three deliberate omissions, all from the
   brief and all load-bearing:

   1. No specific models, shades or prices - the stock has only partly
      arrived, and someone turning up for something listed but not in stock
      costs both the sale and the trust.
   2. Nothing about postage, in either direction.
   3. The CTA books a consultation; it never says "order". */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Bredcrumb from '../../HomeMain/Bredcrumb';
import Appointment from '../../HomeMain/Appointment';
import Faq from '../../ui/Faq';
import {
  Section, Heading, P, FeatureList, CompareTable, Callout, buttonStyle, INK,
} from '../../ui/blocks';
import { linkTo } from '../../../i18n/lang.mjs';
import { WIGS_ENABLED } from '../../../config/features.mjs';

const WIGS = '/perike';

const Main = () => {
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';
  const wigsHref = linkTo(WIGS, lang);

  /* The third card is the wigs one - dropped while wigs are out of stock.
     See src/config/features.mjs. */
  const offer = t('hairExtensions.offer.items', { returnObjects: true })
    .slice(0, WIGS_ENABLED ? 3 : 2);
  const compare = t('hairExtensions.compare', { returnObjects: true });
  const care = t('hairExtensions.care.items', { returnObjects: true });
  const faq = t('hairExtensions.faq.items', { returnObjects: true });

  return (
    <>
      <Bredcrumb title={t('pages.hairExtensions.title')} subtitle={t('pages.hairExtensions.subtitle')} />

      <Section>
        <P style={{ fontSize: '18px', color: INK, fontWeight: 500 }}>{t('hairExtensions.intro.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairExtensions.intro.p2')}</P>
      </Section>

      <Section tinted>
        <Heading>{t('hairExtensions.whatAre.heading')}</Heading>
        <P>{t('hairExtensions.whatAre.p1')}</P>
        <P>{t('hairExtensions.whatAre.p2')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairExtensions.whatAre.p3')}</P>
      </Section>

      <Section>
        <Heading>{t('hairExtensions.offer.heading')}</Heading>
        <FeatureList items={offer} />
        {WIGS_ENABLED && (
          <div style={{ marginTop: '20px' }}>
            <Link to={wigsHref} style={buttonStyle('outline')}>
              {t('hairExtensions.offer.wigsLink')}
            </Link>
          </div>
        )}
      </Section>

      <Section tinted>
        <Heading>{compare.heading}</Heading>
        <P>{compare.intro}</P>
        <CompareTable columns={compare.columns} rows={compare.rows} />
        <Callout tone="gold">{compare.advice}</Callout>
      </Section>

      <Section>
        <Heading>{t('hairExtensions.lengths.heading')}</Heading>
        <P>{t('hairExtensions.lengths.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairExtensions.lengths.p2')}</P>
      </Section>

      <Section tinted>
        <Heading>{t('hairExtensions.shade.heading')}</Heading>
        <P>{t('hairExtensions.shade.p1')}</P>
        <P>{t('hairExtensions.shade.p2')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairExtensions.shade.p3')}</P>
      </Section>

      <Section>
        <Heading>{t('hairExtensions.care.heading')}</Heading>
        <FeatureList items={care} />
        <P style={{ marginTop: '20px', marginBottom: 0, fontWeight: 600, color: INK }}>
          {t('hairExtensions.care.closing')}
        </P>
      </Section>

      <Section tinted>
        <Heading>{t('hairExtensions.tryIt.heading')}</Heading>
        <P style={{ fontWeight: 600, color: INK }}>{t('hairExtensions.tryIt.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairExtensions.tryIt.p2')}</P>
      </Section>

      <Section>
        <Heading align="center">{t('hairExtensions.faq.heading')}</Heading>
        <Faq items={faq} />
      </Section>

      {/* Same booking form as /contact, pre-filled with this page's service. */}
      <Appointment defaultService="Ekstenzije za kosu" />

    </>
  );
};

export default Main;
